import usePrefix from '@/hooks/usePrefix';
import { IAirport, IGuide, IMonthly } from '@/types';
import { Button, Divider } from 'antd';
import Link from 'next/link';
import React, { ReactElement, useState } from 'react';

export interface IGuideList {
  airports: { result: IAirport[]; guides: IGuide[]; monthlies: IMonthly[] };
  grid?: number;
  gap?: number;
}

function MonthliesList({
  airports,
  grid = 4,
  gap = 2,
}: IGuideList): ReactElement {
  const prefix = usePrefix();
  return (
    <div
      className={`grid grid-cols-1 md:grid-cols-${grid} gap-y-2 gap-x-${gap} place-items-start`}
    >
      {airports?.monthlies?.map((monthly: IMonthly) => (
        <Link
          href={`${prefix}/monthly/${monthly.monthly_friendly_url}`}
          key={monthly.monthly_id}
          className="text-primary hover:underline hover:text-primary"
          title={monthly.monthly_name}
        >
          »{monthly.monthly_name}
        </Link>
      ))}
    </div>
  );
}

function Monthlies({ airports }): ReactElement {
  const [showAllMonthlies, setShowAllMonthlies] = useState(false);
  if (!airports?.monthlies || airports?.monthlies.length == 0) return <></>;
  return (
    <div className="container px-4 mx-auto">
      <div
        className={`shadow-sm overflow-hidden ${
          showAllMonthlies ? 'h-auto' : 'h-60 md:h-32'
        } rounded-md flex flex-col py-6 px-6 mt-8 mx-2 border`}
      >
        <div className="w-full grid grid-cols-1 md:grid-cols-3">
          <div className="col-span-2">
            <h2 className="text-2xl text-center md:text-left">
              Our Monthly Parking
            </h2>
            <p className="pt-2 lg:py-0 text-center md:text-left max-w-2xl">
              Looking for a great deal on monthly parking? You've come to the
              right place! We've done all the searching for you, and put
              together the best locations at the best rates. All you have to do
              is book it!
            </p>
          </div>
          <div className="flex justify-center mt-4 md:justify-end md:mt-0 items-center">
            <Button
              type="primary"
              size="large"
              className="rounded-full uppercase bg-primary"
              onClick={() => setShowAllMonthlies(!showAllMonthlies)}
            >
              {showAllMonthlies
                ? 'Hide Monthly Parking'
                : 'View All Monthly Parking'}
            </Button>
          </div>
        </div>

        <div
          className={`w-full pt-8 ${
            showAllMonthlies ? 'visible' : 'invisible'
          }`}
        >
          <Divider />
          <MonthliesList airports={airports} />
        </div>
      </div>
    </div>
  );
}

export default Monthlies;
